import { Box, CardBody, CardFooter, CardHeader, FormControl, FormErrorMessage, FormLabel, Input, VStack } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { SubmitBtn } from "../../atoms/button/SubmitBtn";
import { useRegisterIfreaAnalyticsSettingForm } from "../../../hooks/ifreaAnalytics/useRegisterIfreaAnalyticsSettingForm";
import { useRegisterIfreaAnalyticsSetting } from "../../../hooks/ifreaAnalytics/useRegisterIfreaAnalyticsSetting";
import { DarkShadowCard } from "../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../molecules/card/CardHeading";
import { SettingsIcon } from "@chakra-ui/icons";


export const RegisterIfreaAnalyticsSettings = () => {
  const { restaurantId } = useParams();
  const { handleSubmit, register, isSubmitting, errors } = useRegisterIfreaAnalyticsSettingForm();
  const onSubmit = useRegisterIfreaAnalyticsSetting(restaurantId);
  const ifreaAnalyticsRestaurantIdError = errors.ifrea_analytics_restaurant_id?.message;
  return (
    <Box m='auto' w={{base: '100%', md: '600px'}}>
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <DarkShadowCard>
          <CardHeader>
            <CardHeading icon={<SettingsIcon />} heading='ifreaアナリティクス設定'/>
          </CardHeader>
          <CardBody py={2}>
            <VStack spacing={5}>
              <FormControl isRequired isInvalid={!!errors.ifrea_analytics_restaurant_id} w='100%'>
                <FormLabel>ifreaアナリティクス店舗ID</FormLabel>
                <Input type="text" {...register('ifrea_analytics_restaurant_id')} />
                <FormErrorMessage>{ifreaAnalyticsRestaurantIdError}</FormErrorMessage>
              </FormControl>
            </VStack>
          </CardBody>
          <CardFooter>
            <SubmitBtn isLoading={isSubmitting}>登録</SubmitBtn>
          </CardFooter>
        </DarkShadowCard>
      </form>
    </Box>
  );
};